import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-research',
  templateUrl: './research.component.html',
  styleUrls: ['./research.component.scss']
})
export class ResearchComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Research: Pioneering Innovation and Knowledge');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI’s Research initiatives, driving innovation, discovery, and academic excellence through groundbreaking studies and collaborative projects.`
        });
    }

}
